<template>
  <div class="th-full-screen th-auth" style="padding-top: 50px">
    <div style="margin-bottom: 40px;">
      <div class="flex justify-center">
        <router-link to="/" @click.native="changeMenu('Utama')">
          <img class="m-auto" width="225" src="/img/Logo.png" alt="logo-tholhah">
        </router-link>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
